module.exports = __webpack_public_path__ + "img/DescriptionOfConventionalEquineHardwareFailureMechanism.c8c8ec60.jpg";